import React, { useState } from 'react'
import { BreadcrumbView } from '../../../../../../context/breadcrumb.context'
import { IconAdd } from '../../../../../../shared/icon/icon'
import { CardFullHeightScrollY } from '../../../../../../shared/card/card-full-height-scroll-y'
import { Card } from '../../../../../../shared/card/card'
import { FormSimple } from '../../../../../../shared/form-simple/form'
import { FormSimpleText } from '../../../../../../shared/form-simple/form-text'
import { FormSimpleSubmitCreate } from '../../../../../../shared/form-simple/form-submit'
import { FormSimpleSelectStr } from '../../../../../../shared/form-simple/form-select-str'
import { useHistory } from 'react-router-dom'
import { FormSimplePersistenceDefaultValue } from '../../../../../../shared/form-simple/form-persistence-default-value'
import { FormSimpleHiddenNumber } from '../../../../../../shared/form-simple/form-hidden-number'
import { useApiFormSaveItem, useApiListSaveType } from '../../../../../../api-new/state/content'

export const NodeSaveItemAdd = ({ nodeID, parentURL }) => {
  const history = useHistory()

  const apiListSaveType = useApiListSaveType()
  const apiFormSaveItem = useApiFormSaveItem()

  const [dirty, updateDirty] = useState({})

  const handleMatch = () => apiListSaveType.get()

  const handleSubmit = async data => {
    await apiFormSaveItem.post(data)
    history.replace(parentURL)
  }

  return (
    <BreadcrumbView Icon={IconAdd} text="add" onMatch={handleMatch}>
      <CardFullHeightScrollY>
        <Card title="add configuration">
          <FormSimple state={apiFormSaveItem.form} onChange={updateDirty} onSubmit={handleSubmit}>
            <FormSimpleHiddenNumber name="nodeID" value={nodeID} required />
            <FormSimpleText name="name" required />
            <FormSimpleSelectStr name="type" items={apiListSaveType.items} required />
            <FormSimplePersistenceDefaultValue name="value" type={dirty.type} required />
            <FormSimpleSubmitCreate backURL={parentURL} />
          </FormSimple>
        </Card>
      </CardFullHeightScrollY>
    </BreadcrumbView>
  )
}
